export class LpConstants {
  static readonly EOL_EXAM_PRE_ANNOUNCEMENT = 63582;
  static readonly STUDY_BUNDLE_URL = '/';
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/lp-constants.ts